import { Action } from 'redux';
import { Pet } from 'types/Pet';

export const PETS_RESET = 'pets/reset';
export const PETS_ERROR = 'pets/error';

export const PETS_SAVE_START = 'pets/save_start';
export const PETS_SAVE_SUCCESS = 'pets/save_success';

interface PetsResetAction extends Action<typeof PETS_RESET> {}
interface PetsErrorAction extends Action<typeof PETS_ERROR> {}

interface PetsSaveStartAction extends Action<typeof PETS_SAVE_START> {}

interface PetsSaveSuccessAction extends Action<typeof PETS_SAVE_SUCCESS> {
    payload: {
        pet: Pet;
    };
}

export type PetsAction =
    | PetsResetAction
    | PetsErrorAction
    | PetsSaveStartAction
    | PetsSaveSuccessAction;
